import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrivacySection } from 'admin-common';
import { translatedList } from 'src/app/shared/utils/translated-content';

@Component({
    selector: 'app-privacy-page',
    templateUrl: './privacy-page.component.html',
    styleUrls: ['./privacy-page.component.scss'],
    standalone: false
})
export class PrivacyPageComponent {

  bigTitle: string = 'homePage.privacy.bigTitle';
  contactEmail: string = 'contact@wissalgroup.com';

  /** Sections in the current language; `{contactEmail}` is filled by lib-privacy-policy. */
  dataPrivacy: PrivacySection[];

  constructor(translate: TranslateService) {
    this.dataPrivacy = translatedList<PrivacySection>(translate, 'homePage.privacy.sections');
  }
}
